<div class="settings">
  <nz-layout class="settings__layout">
    <!-- Sidebar Navigation -->
    <nz-sider class="settings__sider" nzWidth="250px">
      <ul class="settings__nav">
        <li
          class="settings__nav-item"
          *ngFor="let item of siderMenu; let i = index"
          [ngClass]="{
            'settings__nav-item--active': activeItem === i,
          }"
          (click)="setActiveItem(i)"
        >
          {{ item.label }}
        </li>
      </ul>
    </nz-sider>

    <!-- Account -->
    <nz-content class="settings__account__content" *ngIf="activeItem === 0">
      <h2
        class="settings__account__title"
        *ngIf="siderMenu[activeItem].title as title"
      >
        {{ title }}
      </h2>
      <div class="settings__account__section">
        <div class="settings__account__profile">
          <img
            src="/assets/images/account/profile-pic.png"
            alt="Profile"
            class="settings__account__avatar"
          />
          <form nz-form class="settings__account__form">
            <div class="settings__account__row">
              <div class="settings__account__col">
                <div class="settings__account__form-item">
                  <label for="username" class="settings__account__form-label"
                    >Nickname</label
                  >
                  <div class="settings__account__form-control">
                    <input
                      class="settings__account__input"
                      id="username"
                      placeholder="blue-formanite-123"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="settings__account__row">
              <div class="settings__account__col">
                <div class="settings__account__form-item">
                  <label for="firstName" class="settings__account__form-label"
                    >First Name</label
                  >
                  <div class="settings__account__form-control">
                    <input
                      class="settings__account__input"
                      id="firstName"
                      placeholder="John"
                    />
                  </div>
                </div>
              </div>
              <div class="settings__account__col">
                <div class="settings__account__form-item">
                  <label for="lastName" class="settings__account__form-label"
                    >Last Name</label
                  >
                  <div class="settings__account__form-control">
                    <input
                      class="settings__account__input"
                      id="lastName"
                      placeholder="Doe"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="settings__account__row">
              <div class="settings__account__col">
                <div class="settings__account__form-item">
                  <label for="email" class="settings__account__form-label"
                    >Email</label
                  >
                  <div class="settings__account__form-control">
                    <input
                      class="settings__account__input"
                      id="email"
                      placeholder="johndoe@example.com"
                    />
                  </div>
                </div>
              </div>
              <div class="settings__account__col">
                <div class="settings__account__form-item">
                  <label for="phone" class="settings__account__form-label"
                    >Phone</label
                  >
                  <div class="settings__account__form-control">
                    <input
                      class="settings__account__input"
                      id="phone"
                      placeholder="(123) 456-7890"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="settings__account__actions">
              <button
                class="settings__account__button settings__account__button--cancel"
              >
                Cancel
              </button>
              <button
                class="settings__account__button settings__account__button--save"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Connect Accounts Section -->
      <div class="settings__account__section">
        <h2 class="settings__account__title settings__account__title--connect">
          Connect Accounts
        </h2>
        <div class="settings__account__social-buttons">
          <button
            nz-button
            nzType="default"
            class="settings__account__social-buttons__button"
            (click)="signInWithGoogle()"
          >
            Connect with Google
          </button>
          <!-- <button
            *ngFor="let account of accounts"
            nz-button
            nzType="default"
            class="settings__account__social-buttons__button"
          >
            {{ account }}
          </button> -->
        </div>
        <div class="settings__account__actions">
          <button
            class="settings__account__button settings__account__button--cancel"
          >
            Cancel
          </button>
          <button
            class="settings__account__button settings__account__button--save"
          >
            Save
          </button>
        </div>
      </div>
    </nz-content>

    <!-- Payment Settings -->
    <nz-content class="settings__payment__content" *ngIf="activeItem === 1">
      <h2
        class="settings__payment__title"
        *ngIf="siderMenu[activeItem].title as title"
      >
        {{ title }}
      </h2>
      <div class="settings__account__section">
        <div class="settings__account__section__active-methods-container">
          <h2
            class="settings__account__section__active-methods-container__title"
          >
            Active Methods
          </h2>
          <div
            class="settings__account__section__active-methods-container__method"
          >
            <div nz-flex nzAlign="center" nzGap="20px">
              <img
                class="settings__account__section__active-methods-container__method-image"
                src="../../assets/images/account/paypal.png"
                alt=""
              />
              **** **** **** 5423
            </div>
            <span
              class="settings__account__section__active-methods-container__method-type-default"
            >
              Default
            </span>
          </div>

          <div
            class="settings__account__section__active-methods-container__method"
          >
            <div nz-flex nzAlign="center" nzGap="20px">
              <img
                class="settings__account__section__active-methods-container__method-image"
                src="../../assets/images/account/paypal.png"
                alt=""
              />
              **** **** **** 5423
            </div>
            <span
              class="settings__account__section__active-methods-container__method-type-declined"
            >
              Declined
            </span>
          </div>
        </div>

        <div class="settings__account__section__payment-option">
          <h2 class="settings__account__section__payment-option__title">
            Choose Payment Option
          </h2>
          <div
            class="settings__account__section__payment-option__details"
          ></div>
        </div>

        <div nz-flex [nzVertical]="true" nzGap="10px">
          <div
            class="settings__account__section__active-methods-container__method"
          >
            <div nz-flex nzAlign="center" nzGap="20px">
              <img
                class="settings__account__section__active-methods-container__method-image"
                src="../../assets/images/account/paypal.png"
                alt=""
              />
              **** **** **** 5423
            </div>
          </div>

          <div
            class="settings__account__section__active-methods-container__method"
          >
            <div nz-flex nzAlign="center" nzGap="20px">
              <img
                class="settings__account__section__active-methods-container__method-image"
                src="../../assets/images/account/paypal.png"
                alt=""
              />
              **** **** **** 5423
            </div>
          </div>
        </div>
      </div>

      <div class="address-container">
        <h2 class="title">Address</h2>

        <form
          nz-form
          [formGroup]="paymentForm"
          (ngSubmit)="submitPaymentForm()"
          autocomplete="off"
          class="form"
        >
          <div class="form-item">
            <label class="item-label">Country</label>
            <nz-input-group>
              <nz-select
                nzPlaceHolder="Country"
                formControlName="country"
                class="item-select"
                autocomplete="new-country"
                name="country"
              >
                <nz-option nzLabel="United States" nzValue="US"></nz-option>
                <nz-option nzLabel="Germany" nzValue="DE"></nz-option>
              </nz-select>
            </nz-input-group>
            <div
              *ngIf="
                f['country']?.errors?.['required'] && f['country']?.touched
              "
              class="form-error"
            >
              * Country selection is required
            </div>
          </div>

          <div class="form-item-row">
            <div class="form-item">
              <label class="item-label">ZIP</label>
              <nz-input-group>
                <input
                  nz-input
                  placeholder="ZIP/Postal code"
                  formControlName="zip"
                  class="item-input"
                  autocomplete="new-zip"
                  name="zip"
                />
              </nz-input-group>
              <div
                class="form-error"
                *ngIf="f['zip']?.errors?.['required'] && f['zip']?.touched"
              >
                * Please enter your ZIP/Postal code
              </div>
            </div>
            <div class="form-item">
              <label class="item-label">City</label>
              <nz-input-group>
                <input
                  nz-input
                  placeholder="City"
                  formControlName="city"
                  class="item-input"
                  autocomplete="new-city"
                  name="city"
                />
              </nz-input-group>
              <div
                class="form-error"
                *ngIf="f['city']?.errors?.['required'] && f['city']?.touched"
              >
                * Please enter your city
              </div>
            </div>
          </div>

          <div class="form-item">
            <label class="item-label">Address</label>
            <nz-input-group>
              <input
                nz-input
                placeholder="Address"
                formControlName="address"
                class="item-input"
                autocomplete="new-address"
                name="address"
              />
            </nz-input-group>
            <div
              class="form-error"
              *ngIf="
                f['address']?.errors?.['required'] && f['address']?.touched
              "
            >
              * Please enter your address
            </div>
          </div>

          <button nz-button nzType="primary" type="submit" class="submit-btn">
            Register
          </button>
        </form>
      </div>

      <div class="membership-container">
        <div class="membership-card">
          <h2 class="title">Current Membership</h2>
          <span class="price">$20/Month</span>
          <button class="subscription-btn" nz-button nzType="primary">
            Cancel Subscription
          </button>
        </div>

        <div class="membership-card">
          <h2 class="title">Current Membership</h2>
          <span class="price">$20/Month</span>
          <button class="subscription-btn" nz-button nzType="primary">
            Cancel Subscription
          </button>
        </div>
      </div>
    </nz-content>

    <!-- Transactions -->
    <nz-content
      class="settings__transactions__content"
      *ngIf="activeItem === 2"
    >
      <!-- <h2
        class="settings__transactions__title"
        *ngIf="siderMenu[activeItem].title as title"
      >
        {{ title }}
      </h2>
      <div class="settings__account__section"></div> -->
      <div class="contact">
        <div class="contact__header">
          <span class="contact__header-item">Type</span>
          <span class="contact__header-item">Date</span>
          <span class="contact__header-item">Transaction ID</span>
          <span class="contact__header-item">Amount</span>
          <span class="contact__header-item">Status</span>
        </div>

        <div class="contact__list">
          <div class="contact__item" *ngFor="let transaction of transactions">
            <div class="contact__item-type">
              <img
                src="assets/images/account/paypal.png"
                alt="PayPal Icon"
                class="contact__item-icon"
              />
              <span class="contact__item-type-text" nz-flex [nzVertical]="true">
                <span class="contact__item-type-text__type">PayPal</span>
                <span class="contact__item-type-text__action">Withdraw</span>
              </span>
            </div>
            <div class="contact__item-date" nz-flex [nzVertical]="true">
              <span class="contact__item-date-text">May 10, 2024</span>
              <span class="contact__item-date-time">04:30 PM</span>
            </div>
            <div class="contact__item-transaction-id">KWIK9X22</div>
            <div class="contact__item-amount">$230.00</div>
            <div
              class="contact__item-status"
              [ngClass]="
                transaction.status === 'Completed'
                  ? 'contact__item-status--completed'
                  : 'contact__item-status--pending'
              "
            >
              {{ transaction.status }}
            </div>
            <div class="contact__item-download">
              <span nz-icon nzType="ng-zorro:download"></span>
            </div>
          </div>
        </div>
      </div>
    </nz-content>

    <!-- Support -->
    <nz-content class="settings__support__content" *ngIf="activeItem === 3">
      <h2 class="settings__support__title">
        {{ siderMenu[activeItem].title }}
      </h2>

      <!-- FAQ Section with nz-collapse -->
      <div>
        <nz-collapse
          class="settings__faq"
          nzBordered="false"
          [nzGhost]="true"
          nzAccordion
        >
          <nz-collapse-panel
            *ngFor="let faq of faqs"
            [nzHeader]="faq.question"
            [ngStyle]="{
              'background-color': 'rgba(255,255,255,0.05)',
              color: 'white',
              'border-radius': '10px',
              'margin-bottom': '20px',
            }"
            [nzShowArrow]="false"
          >
            <p class="settings__faq-answer">{{ faq.answer }}</p>
          </nz-collapse-panel>
        </nz-collapse>
      </div>

      <!-- Contact Us Section -->
      <div class="settings__contact">
        <h3 class="settings__contact-title">Contact Us</h3>
        <p class="settings__contact-description">
          Our team is constantly working on improving your experience. Let us
          know what we could do for you.
        </p>
        <form
          [formGroup]="contactForm"
          (ngSubmit)="submitContactForm()"
          class="settings__contact-form"
        >
          <div nz-flex nzGap="10px">
            <nz-form-item class="w-full">
              <nz-form-control>
                <label for="name" class="settings__contact-form-label"
                  >Name</label
                >
                <input
                  nz-input
                  id="name"
                  formControlName="name"
                  placeholder="Name"
                />
                <div
                  *ngIf="
                    contactForm.get('name')?.errors &&
                    (contactForm.get('name')?.touched ||
                      contactForm.get('name')?.dirty)
                  "
                  class="settings__contact-form-error"
                >
                  Name is required.
                </div>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item class="w-full">
              <nz-form-control>
                <label for="email" class="settings__contact-form-label"
                  >Email</label
                >
                <input
                  nz-input
                  id="email"
                  formControlName="email"
                  placeholder="Email"
                />
                <div
                  *ngIf="
                    contactForm.get('email')?.hasError('required') &&
                    (contactForm.get('email')?.touched ||
                      contactForm.get('email')?.dirty)
                  "
                  class="settings__contact-form-error"
                >
                  Email is required.
                </div>
                <div
                  *ngIf="
                    contactForm.get('email')?.hasError('email') &&
                    (contactForm.get('email')?.touched ||
                      contactForm.get('email')?.dirty)
                  "
                  class="settings__contact-form-error"
                >
                  Please enter a valid email.
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>

          <nz-form-item>
            <nz-form-control>
              <label for="query" class="settings__contact-form-label"
                >Query</label
              >
              <textarea
                nz-input
                id="query"
                formControlName="query"
                placeholder="Let us know the problem"
                rows="8"
              ></textarea>
              <div
                *ngIf="
                  contactForm.get('query')?.errors &&
                  (contactForm.get('query')?.touched ||
                    contactForm.get('query')?.dirty)
                "
                class="settings__contact-form-error"
              >
                Query is required.
              </div>
            </nz-form-control>
          </nz-form-item>

          <button
            class="submit-btn"
            nz-button
            nzType="primary"
            nzBlock
            [disabled]="contactForm.invalid"
          >
            Submit
          </button>
        </form>

        <div class="settings__contact-info">
          <div class="phone">
            <div class="icon-container">
              <i nz-icon nzType="ng-zorro:phone-calling"></i>
            </div>
            <div>
              <span class="phone-number">+ (8561) 0936-492</span>
              <br />
              <span class="closing-text"> We are always happy to help </span>
            </div>
          </div>

          <div class="support">
            <div class="icon-container">
              <i nz-icon nzType="ng-zorro:letter"></i>
            </div>
            <div>
              <span class="support-email">{{ 'Support@helpenter.com' }}</span>
              <br />
              <span class="closing-text">Fastest way to get response</span>
            </div>
          </div>
        </div>
      </div>
    </nz-content>
  </nz-layout>
</div>
